// App.js
import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import './App.css';
import Login from './Screens/Login/Login';
import AdminPage from './Screens/Admin/AdminPage';
import { checkToken } from './API/functions'; // import your new check function

function App() {
  const [authState, setAuthState] = useState(null);
  // Possible values:
  // null => not yet checked
  // false => not authenticated
  // object => e.g. { valid: true, isAdmin: true, userId, email }

  useEffect(() => {
    async function validateToken() {
      const result = await checkToken();
      if (!result) {
        setAuthState(false);
      } else {
        setAuthState(result);
      }
    }
    validateToken();
  }, []);

  if (authState === null) {
    // We haven't finished checking the server
    // Show a loader or blank screen
    return <div>Loading...</div>;
  }

  return (
    <Router>
      <div className="App">
        <Routes>
          {/* If not authenticated, show login on root path */}
          <Route
            path="/"
            element={
              authState ? <Navigate to="/admin" /> : <Login />
            }
          />

          <Route
            path="/admin"
            element={
              authState ? <AdminPage /> : <Navigate to="/" />
            }
          />

          <Route
            path="*"
            element={
              authState ? <Navigate to="/admin" /> : <Login />
            }
          />
        </Routes>
      </div>
    </Router>
  );
}

export default App;
